import 'react-native-get-random-values';
import React, {useEffect, useState} from 'react';
import {Keyboard, StyleSheet, Text, TextInput, TouchableOpacity, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {
    getConnectionLogs,
    getConnectionStatus,
    getCurrentState,
    getServerUrl,
    setAuthenticated,
    setError,
    setLoading,
    setLogsVisibility,
    setServerUrl,
    setSocketUrl, setSoketiUrl,
    setToken,
} from "../reducers/configSlice";
import Scanner from "../components/Scanner";
import {GestureHandlerRootView} from "react-native-gesture-handler";
import {v4 as uuidv4} from 'uuid';
import {apiRegisterDevice} from "../api/actions";
import {initSocketService} from "../services/socket/socket";
import {STORAGE} from "../services/storage";
import {SOCKET_CONNECTED, STATE_ACTIVATE} from "../constants/default";
import HiddenLongPress from "../components/HiddenLongPress";
import LogsContainer from "../components/LogsContainer";
import {FONT_FAMILY_BOLD, FONT_FAMILY_BOLDER} from "../constants/styleConstants";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";
import {useKeyboardVisibility} from "../services/hooks/useKeyboardVisibility";
import {getBaseUrlFromSocket} from "../services/helpers/getBaseUrlFromSocket";
import {isWEB} from "../services/helpers/getPlatformType";
import {initSoketiService} from "../services/soketi";
import {storeDeviceUuid} from "../services/helpers/getDeviceUuid";

const REGISTRATION_MODE_QR = 0;
const REGISTRATION_MODE_MANUAL = 1;

const ActivateDevice = () => {
    const dispatch = useDispatch()
    const serverUrl = useSelector(getServerUrl)
    const connectionStatus = useSelector(getConnectionStatus)
    const currentState = useSelector(getCurrentState)
    const connectionLogs = useSelector(getConnectionLogs)

    const [logsVisible, setLogsVisible] = useState(false)
    const [scanned, setScanned] = useState(false)
    const [registrationMode, setRegistrationMode] = useState(REGISTRATION_MODE_MANUAL)
    const [activationKey, setActivationKey] = useState('')
    const hideRegistrationSwitcher = useKeyboardVisibility();

    const handleBarCodeScanned = async ({ data }) => {
        if (!data || scanned) return;

        try {
            data = JSON.parse(data)
            setScanned(true)

            if (!(data && data.hash && data.company_id && data.url)) {
                return;
            }

            const success = await registerDevice(data.hash, data.company_id, data.url);

            if (!success) setScanned(false);
        } catch (Error) {
            dispatch(setError(Error.message))
            setScanned(false)
        }
    };

    const handleActivationKeyRegistration = async () => {
        if (!serverUrl || !activationKey) return;

        const success = await registerDevice(activationKey, null, serverUrl);

        if (!success) setScanned(false);
    }

    const registerDevice = async (hash, companyId, dataUrl) => {
        let providedServerUrl = generateApiUrl(dataUrl);

        await STORAGE.set('baseUrl', providedServerUrl);
        dispatch(setServerUrl(providedServerUrl));

        const uuid = uuidv4();
        const { response, error } = await apiRegisterDevice(uuid, hash, companyId, true);

        if (error || !response?.token) {
            dispatch(setLoading(false));
            dispatch(setError(error));
            setScanned(false);
            return false; // Indicate failure
        }

        // Store UUID for future token refresh requests
        await storeDeviceUuid(uuid);

        const socketUrl = response.soketi_url ? null : (response.socket_url + "?token=" + response.token);

        if (providedServerUrl && socketUrl && (
            providedServerUrl.includes('api.yarooms.com') ||
            providedServerUrl.includes('api.eu.yarooms') ||
            providedServerUrl.includes('api.ca.yarooms')
        )) {
            providedServerUrl = getBaseUrlFromSocket(socketUrl)
            await STORAGE.set("baseUrl", providedServerUrl)
            dispatch(setServerUrl(providedServerUrl));
        }

        await STORAGE.set('socketUrl', socketUrl);
        await STORAGE.set("token", response.token);

        // Check for Soketi URL and store it
        if (response.soketi_url) {
            dispatch(setSoketiUrl(response.soketi_url));
            await STORAGE.set('soketiUrl', response.soketi_url);
        }

        dispatch(setError(null));
        dispatch(setToken(response.token));

        // Only set socketUrl if not using Soketi
        if (!response.soketi_url) {
            dispatch(setSocketUrl(socketUrl));
        }

        dispatch(setAuthenticated(true));

        dispatch(setLoading(true));

        if (response.soketi_url) {
            await initSoketiService();
        } else if (socketUrl) {
            await initSocketService();
        }

        setTimeout(async () => {
            if (connectionStatus !== SOCKET_CONNECTED && currentState === STATE_ACTIVATE) {
                setScanned(false);
                dispatch(setLoading(false));
            }
        }, 35000);

        return true; // Indicate success
    };


    const changeRegistrationMode = async () => {
        setRegistrationMode(registrationMode === REGISTRATION_MODE_QR ? REGISTRATION_MODE_MANUAL : REGISTRATION_MODE_QR)
        dispatch(setServerUrl(''))
        await STORAGE.set('baseUrl', '');
    }

    const _showConnectionLogs = async () => {
        Keyboard.dismiss()
        dispatch(setLogsVisibility(true))
    }

    const generateApiUrl = (url) => {
        if (url.endsWith('/')) {
            url = url.slice(0, -1);
        }

        if (!url.endsWith('/api')) {
            url += '/api';
        }

        if (url.includes('://')) {
            url = 'https://' + url.split('://')[1];
        } else {
            url = 'https://' + url
        }

        return url;
    }

    return (
        <GestureHandlerRootView style={styles.container}>
            <View style={[styles.keyboardAvoidingView]}>
                <View style={{flex: 1, alignItems: 'center', justifyContent: 'center', width: isWEB() ? '100%' : 'auto'}}>
                    <View style={[{marginBottom: actuatedNormalize(25), width: '50%'}, hideRegistrationSwitcher && {opacity: 0}]}>
                        <Text style={[styles.titleText]}>{translate("Register device")}</Text>
                        <Text style={[styles.subTitleText]}>{registrationMode === REGISTRATION_MODE_QR ? translate("Place the QR code from the Integrations page from YAROOMS in front of the camera") : translate("Enter the activation key from the Integrations page from YAROOMS")}.</Text>
                    </View>
                    {
                        registrationMode === REGISTRATION_MODE_QR ?
                            <Scanner onScanned={handleBarCodeScanned} embed={true}/> :
                            <View style={{width: isWEB() ? '100%': 'auto', flex: 0.6, justifyContent: 'center', alignItems: 'center'}}>
                                <View style={[styles.wrapper]}>
                                    <Input placeholder={'https://tenant.yarooms.com'}
                                        value={serverUrl} style={{width: '100%'}}
                                        onChange={ async (input) => {
                                            dispatch(setServerUrl(input));
                                            await STORAGE.set('baseUrl', input);
                                        } }
                                    />
                                </View>

                                <View style={[styles.wrapper]}>
                                    <Input
                                        placeholder={translate("Enter your activation key")}
                                        value={activationKey}
                                        onChange={ (input) => setActivationKey(input) }
                                    />
                                </View>

                                <View style={[styles.wrapper]}>
                                    <Button
                                        disabled={!activationKey || !serverUrl}
                                        onPress={handleActivationKeyRegistration}
                                        text={translate("Activate device")}
                                    />
                                </View>
                            </View>
                    }
                    {
                        !hideRegistrationSwitcher ?
                            <TouchableOpacity style={{position: 'absolute', bottom: actuatedNormalize(35)}} onPress={changeRegistrationMode}>
                                <Text style={[styles.subTitleText]}>{registrationMode === REGISTRATION_MODE_QR ? translate("tap here for manual registration") : translate("tap here for QR registration")}</Text>
                            </TouchableOpacity> : null
                    }
                </View>
            </View>

            <HiddenLongPress onEvent={_showConnectionLogs} position={'bottomLeft'}/>
            <LogsContainer />
        </GestureHandlerRootView>
    )
}

const Input = ({ placeholder, value, onChange, onSubmit }) => {
    return (
        <TextInput
            style={[styles.input]}
            underlineColorAndroid="transparent"
            placeholder={placeholder}
            placeholderTextColor="#8F8F8F"
            autoCapitalize="none"
            value={value}
            onChangeText={onChange}
            onSubmitEditing={onSubmit}
        />
    )
}

const Button = ({disabled, onPress, text}) => {
    return (
        <TouchableOpacity style={[styles.activateButton, disabled && { backgroundColor: 'rgb(29, 63, 111)', opacity: 0.75 }]} disabled={disabled} onPress={onPress}>
            <Text adjustsFontSizeToFit style={[styles.activateButtonText]}>
                {text.toUpperCase()}
            </Text>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    keyboardAvoidingView: {
        opacity : 1,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    wrapper: {
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: actuatedNormalize(15),
        width: isWEB() ? '50%' : 'auto',
    },
    input: {
        textAlign: 'center',
        fontSize: actuatedNormalize(18),
        fontFamily:FONT_FAMILY_BOLD,
        justifyContent: 'center',
        borderBottomLeftRadius: 5,
        borderTopLeftRadius: 5,
        backgroundColor: 'rgb(255,255,255)',
        borderWidth: 1,
        borderColor: 'rgb(180,180,180)',
        height: actuatedNormalize(45),
        width: isWEB() ? '100%' : '60%',
    },
    activateButton: {
        backgroundColor: '#5B41D9',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomRightRadius: 5,
        borderTopRightRadius: 5,
        height: actuatedNormalize(45),
        width: isWEB() ? '100%' : '60%',
        marginTop: actuatedNormalize(35)
    },
    activateButtonText: {
        justifyContent: 'center',
        fontSize: actuatedNormalize(16),
        color: 'white',
        fontFamily: FONT_FAMILY_BOLDER,
    },
    hiddenOption: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: actuatedNormalize(100),
        height: actuatedNormalize(100),
    },
    titleText: {
        fontFamily: FONT_FAMILY_BOLDER,
        fontSize: actuatedNormalize(16),
        textAlign: 'center',
        color: 'white',
        marginBottom: actuatedNormalize(16)
    },
    subTitleText: {
        fontFamily: FONT_FAMILY_BOLD,
        color: 'white',
        fontSize: actuatedNormalize(14),
        textAlign: 'center',
        width: isWEB() ? '100%' : actuatedNormalize(300)
    }
});

export default ActivateDevice
